/**
 * @generated SignedSource<<2668e891e3e176f4bc411a8ecde3ada4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usePatronImageKitAuthMutation$variables = {
  clubId: string;
  format: string;
};
export type usePatronImageKitAuthMutation$data = {
  readonly imagekitUploadAuth: {
    readonly checks: string;
    readonly fileName: string;
    readonly folder: string;
    readonly overwriteFile: boolean;
    readonly renderingBaseUrl: string;
    readonly token: string;
    readonly useUniqueFileName: boolean;
  } | null | undefined;
};
export type usePatronImageKitAuthMutation = {
  response: usePatronImageKitAuthMutation$data;
  variables: usePatronImageKitAuthMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clubId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "format"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "clubId",
        "variableName": "clubId"
      },
      {
        "kind": "Variable",
        "name": "format",
        "variableName": "format"
      }
    ],
    "concreteType": "ImagekitUploadAuth",
    "kind": "LinkedField",
    "name": "imagekitUploadAuth",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "folder",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "checks",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "useUniqueFileName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "overwriteFile",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "renderingBaseUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePatronImageKitAuthMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePatronImageKitAuthMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0dede5a5e9d3e530be46973e47c108be",
    "id": null,
    "metadata": {},
    "name": "usePatronImageKitAuthMutation",
    "operationKind": "mutation",
    "text": "mutation usePatronImageKitAuthMutation(\n  $clubId: ID!\n  $format: String!\n) {\n  imagekitUploadAuth(clubId: $clubId, format: $format) {\n    token\n    fileName\n    folder\n    checks\n    useUniqueFileName\n    overwriteFile\n    renderingBaseUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "d5af205918ee029d1e05b2929e530c73";

export default node;
